import { CSSProperties } from "react";

export const getCustomerFeatureChartStyles = (cardWidth: number): {
  container: CSSProperties;
  cardContainer: CSSProperties;
} => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
  },
  cardContainer: {
    flex: `0 1 ${cardWidth}px`
  }
});
